/** @format */

import React, { Fragment } from "react";
import { Dropdown, Form, Modal } from "react-bootstrap";

// images

import user1 from "../assets/images/page-img/19.jpg";
import user2 from "../assets/images/page-img/18.jpg";
import user3 from "../assets/images/page-img/20.jpg";
import user4 from "../assets/images/user/06.jpg";
import user5 from "../assets/images/user/08.jpg";
import user6 from "../assets/images/user/15.jpg";
import user7 from "../assets/images/user/13.jpg";
import { Link } from "react-router-dom";

const SearchModal = () => {
  return (
    <Fragment>
      <Dropdown.Menu bsPrefix=" " className={`search-modal-custom`}>
        <div className="search-modal-content">
          <div className="px-3 py-2">
            <div className="d-lg-none w-100">
              <Form action="#" className="searchbox">
                <Form.Control
                  type="text"
                  className="text search-input bg-success-subtle"
                  placeholder="Search here..."
                />
              </Form>
            </div>
          </div>
        </div>
      </Dropdown.Menu>
    </Fragment>
  );
};

export default SearchModal;
